import React from 'react';
import CustomDialog from '../customDialog';
import DotLoader from '../loaders/dotLoader';

function EmailVerified({
  isExpired,
  isVerified,
  popOverContainer,
  btnStyleJoin,
  arrowIcon,
  handleOk,
  handleClose,
}) {
  return (
    <CustomDialog
      open={true}
      handleClose={handleClose}
      popOverContainer={popOverContainer}
      titleText={
        isVerified
          ? 'Email has been verified'
          : isExpired
          ? 'Link Expired!'
          : 'Verifying Email'
      }
      contentText={
        isVerified
          ? 'Congrats! You have successfully verified the email. Please continue..'
          : isExpired
          ? 'This link expired! Please Sign In and request for a new verification link'
          : 'Email verification may take up to few seconds.'
      }
      btnOkCls={btnStyleJoin}
      handleOk={handleOk}
      btnOkText={'Go to website'}
      disableOkBtn={!isVerified}
      arrowIconCls={arrowIcon}
    >
      {isVerified || (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <DotLoader text={''} noContainer={true} />
        </div>
      )}
    </CustomDialog>
  );
}

export default EmailVerified;
